<template>
  <section id="ContentsHead" class="mv">
    <div class="in">
      <div class="model tommy">
        <img
          data-scroll
          :data-scroll-speed="$store.state.isMobile ? 0.5 : -1.2"
          data-scroll-delay="0.45"
          data-scroll-target="#ContentsHead"
          class="person"
          src="@/assets/tommy-full.png"
          alt=""
        />
      </div>
      <div class="model kanta">
        <img
          data-scroll
          :data-scroll-speed="$store.state.isMobile ? -0.5 : -1.4"
          data-scroll-delay="0.05"
          data-scroll-target="#ContentsHead"
          class="person"
          src="@/assets/kanta-full.png"
          alt=""
        />
      </div>
      <svg
        data-scroll
        data-scroll-speed="-1.4"
        data-scroll-delay="0.05"
        data-scroll-target="#ContentsHead"
        class="tri tri-01"
        width="893"
        height="744"
        viewBox="0 0 893 744"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M838.439 43.9556L108.423 172.015L22.4451 689.049L838.439 43.9556Z"
          fill="white"
        />
      </svg>

      <svg
        data-scroll
        data-scroll-speed="-1.4"
        data-scroll-delay="0.05"
        data-scroll-target="#ContentsHead"
        class="tri tri-02"
        width="1071"
        height="659"
        viewBox="0 0 1071 659"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1067.61 54.7115L246.619 56.1227L54.7983 604.108L1067.61 54.7115Z"
          fill="white"
        />
      </svg>

      <svg
        data-scroll
        data-scroll-speed="-1.4"
        data-scroll-delay="0.05"
        data-scroll-target="#ContentsHead"
        class="tri tri-03"
        width="684"
        height="464"
        viewBox="0 0 684 464"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M684 0L409.5 412L0 464L684 0Z" fill="white" />
      </svg>
    </div>
  </section>
</template>

<script>
/* mixin */
import scrollTrigger from '@/mixins/scrollTrigger.js'
export default {
  mixins: [scrollTrigger]
}
</script>

<style lang="scss" scoped>
.mv {
  position: relative;
  width: 100%;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  transform: skewY(-6deg);
  overflow: hidden;
  z-index: 0;
  @media screen and (max-width: $breakpoint-mobile) {
    height: calc(var(--vh, 1vh) * 80);
  }
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
    height: 70vh;
  }

  .in {
    position: relative;
    height: 100%;
    transform: skewY(6deg);
  }
  .model {
    position: absolute;

    &.tommy {
      left: 50%;
      transform: translate(calc(-50% + 30rem), 0);
      @media screen and (max-width: $breakpoint-mobile) {
        top: 4rem;
        transform: translate(calc(-50% + 15rem), 0);
      }
      @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
        transform: translate(calc(-50% + 35rem), 0);
      }

      .person {
        height: 100vh;
        @media screen and (max-width: $breakpoint-mobile) {
          width: 56rem;
          height: auto;
        }

        @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
          height: 70vh;
        }
      }
    }
    &.kanta {
      left: 50%;
      transform: translate(calc(-50% - 24rem), 6rem);
      @media screen and (max-width: $breakpoint-mobile) {
        top: 2rem;
        transform: translate(calc(-50% - 10rem), 0);
        z-index: -9;
      }

      @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
        transform: translate(calc(-50% - 34rem), 6rem);
      }

      .person {
        height: 100vh;
        @media screen and (max-width: $breakpoint-mobile) {
          width: 42rem;
          height: auto;
        }
        @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
          height: 80vh;
        }
      }
    }
  }
  .tri {
    position: absolute;
    z-index: -10;

    &.tri-01 {
      left: -10rem;
      width: 50rem;
      @media screen and (max-width: $breakpoint-mobile) {
        display: none;
      }
    }

    &.tri-02 {
      width: 140rem;
      height: 140rem;
      top: -50rem;
      right: -90rem;
      transform: rotate(90deg);
      @media screen and (max-width: $breakpoint-mobile) {
        top: 20rem;
      }
    }
    &.tri-03 {
      width: 100rem;
      left: -10rem;
      bottom: -8rem;
      z-index: -99;
      @media screen and (max-width: $breakpoint-mobile) {
        width: 50rem;
        left: 0rem;
        bottom: -20rem;
      }
    }
  }
}
</style>
